import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: debug ? 'history' : 'history',
  linkActiveClass: 'is-active',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/app/config/router.js